import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    formControlAutoComplete: {
        minWidth: "100%",
        margin: "10px"
    },

    //highlightCell: { backgroundColor: "rgb(250, 250, 235)" },
    paddingPaper:{
        paddingBottom: theme.spacing(2),
        minHeight:"100%",
        height:"100%"
    },
    heightPaper:{
        minHeight:"100%",
        height:"100%"
    },
    heightScrolledTableTop:{

    },
    centerTypographyRoot: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center"
    },
    table: {
        minWidth: 650,
        height: "50%"
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    marginTop: "10px",
    },
}), {index: 1});